import { sanitizeTableHtml } from '@karakuri-web/common/utils'
import { AnswerContent } from '@karakuri-web/faq-type'

import { MarkdownWithChoiceBlocks } from './ChoiceBlockRenderer'
import { detectTable } from './detectTable'
import { SkillApi } from './interface'
import { renderSkill } from './Skill'
import { renderText } from './Text'
import { detectVideoTouch } from './videoTouch/videoTouch'
import { VideoTouchIframe } from './videoTouch/VideoTouchIframe'
import { detectYoutube } from './youtube/youtube'
import { YoutubeIframe } from './youtube/YoutubeIframe'

export function render(content: AnswerContent, skillApi: SkillApi, cardId: string) {
  const contentText = content?.text || ''

  if (content.contentFormat === 'markdown') {
    return (
      <div className="md">
        <MarkdownWithChoiceBlocks
          answerId={content.id}
          cardId={cardId}
          markdown={contentText}
          skillApi={skillApi}
        />
      </div>
    )
  }
  if (detectTable(contentText)) {
    // 会話カードの回答は一般ユーザーやワークフローの申請からも保存でき、faq-preview では管理画面と同じオリジンで描画されるため無害化する
    return (
      <div
        className="faq-answer-table md"
        dangerouslySetInnerHTML={{ __html: sanitizeTableHtml(contentText) }}
      />
    )
  }
  if (detectYoutube(content)) {
    return <YoutubeIframe youtubeId={content.meta.youtubeId} />
  }
  if (detectVideoTouch(content)) {
    return <VideoTouchIframe videoTouchId={content.meta.videoTouchId} />
  }
  const skill = renderSkill(skillApi, {
    from: 'FAQ_ANSWER',
    text: content.text,
    cardId,
    answerId: content.id,
  })

  if (skill) {
    return skill
  }

  const text = contentText.endsWith('\n') ? contentText : contentText ? `${content.text}\n` : ''
  return renderText(text)
}
